import { render, staticRenderFns } from "./type-name-config.vue?vue&type=template&id=0d4e3f80&"
import script from "./type-name-config.vue?vue&type=script&lang=js&"
export * from "./type-name-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports